module.exports = __webpack_public_path__ + "static/img/feature_1.2a45664.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/feature_1.png
// module id = zWyt
// module chunks = 0